import { Navigate } from "react-router-dom";
import { useEffect } from "react";
import { toast } from "sonner";
import { useAuth } from "../../lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && user && user.role === "chaplain") {
      toast.message("Chaplain accounts use the CCCHAPS Chaplain Portal.");
    }
  }, [loading, user]);

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-sm text-slate-500" data-testid="auth-loading">
        Loading...
      </div>
    );
  }
  if (!user) return <Navigate to="/care-portal/admin/login" replace />;
  // Chaplains do not have access to the Management Center shell.
  if (user.role === "chaplain") return <Navigate to="/chaplain-portal/dashboard" replace />;
  return children;
}
